import { render } from "./wSelect.vue?vue&type=template&id=f4a1c3cc&ts=true"
import script from "./wSelect.vue?vue&type=script&lang=ts"
export * from "./wSelect.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__